import axios from 'axios';
import ProgressDistribution from '@/components/growth/ProgressDistribution.vue';

/**
 * 구매요청 진행현황을 "상태 하나" 대신 "수량 분포" 로 보여주기 위한 공용 조각.
 * 정본: docs/coupass-logistics-chain.md §4, §5 Phase 2-17.
 *
 * 네 화면(구매요청 그로스/노마드, 쿠패스 구매요청 관리, 진행추적)이 같은 규칙을 써야 해서
 * 여기 한 곳에 둔다. 화면마다 복사하면 규칙이 갈린다.
 *
 * ⚠ 안전 원칙 (§4)
 *   선적이 없는 건은 서버가 분포를 아예 안 준다 → distOf() 가 null 을 준다
 *   → 화면은 지금까지 쓰던 processStatus 뱃지를 그대로 그린다.
 *   조회가 실패해도 마찬가지다. 새 필드가 없다고 화면이 비면 안 된다.
 *
 * 쓰는 법
 *   mixins: [shipmentDistributionMixin]
 *   목록을 채운 뒤 →  this.loadShipmentDist(목록)
 *   템플릿에서    →  <ProgressDistribution v-if="distOf(item)" :dist="distOf(item)" />
 *                    <b-badge v-else> ... 기존 뱃지 ... </b-badge>
 */
export default {
    components: { ProgressDistribution },
    data() {
        return {
            // reqId → { 줄:[{상태,수량}], 합계, 구매요청수량, 선적수 }
            shipmentDist: {}
        };
    },
    methods: {
        /**
         * 목록에 달린 선적 분포를 한 번에 받아온다.
         * 건별로 부르면 N+1 이 되므로 목록 단위로만 부른다.
         */
        async loadShipmentDist(list) {
            try {
                const ids = (list || [])
                    .map(e => (e && (e._id || e.id)))
                    .filter(Boolean)
                    .map(String);
                if (!ids.length) { this.shipmentDist = {}; return; }

                const res = await axios.post('/api/reqpurchase/shipmentDistribution', {
                    reqIds: ids.slice(0, 1000)
                });
                this.shipmentDist = (res.data && res.data.요청결과 === '성공' && res.data.분포) || {};
            } catch (error) {
                // 실패해도 화면은 지금 모습 그대로여야 한다. 비우고 넘어간다.
                console.error('선적 분포 조회 오류:', error);
                this.shipmentDist = {};
            }
        },
        /** 이 건의 분포. 없으면 null → 부르는 쪽이 기존 뱃지를 그린다. */
        distOf(item) {
            if (!item) return null;
            const id = String(item._id || item.id || '');
            return (id && this.shipmentDist[id]) || null;
        }
    }
};
